// utils/exportExcel.js
export function exportExcel(api, params, message, fileName) {
  // 添加遮罩层
  const mask = document.createElement('div');
  mask.style.position = 'fixed';
  mask.style.top = '0';
  mask.style.left = '0';
  mask.style.width = '100%';
  mask.style.height = '100%';
  mask.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  mask.style.zIndex = '9999';
  document.body.appendChild(mask);

  // 添加转圈的提示
  const spinner = document.createElement('div');
  spinner.style.position = 'absolute';
  spinner.style.top = '50%';
  spinner.style.left = '50%';
  spinner.style.transform = 'translate(-50%, -50%)';
  spinner.style.border = '4px solid #f3f3f3';
  spinner.style.borderTop = '4px solid #3498db';
  spinner.style.borderRadius = '50%';
  spinner.style.width = '50px';
  spinner.style.height = '50px';
  spinner.style.animation = 'spin 2s linear infinite';
  mask.appendChild(spinner);

  // 添加旋转动画
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);

  api(params).then((response) => {
    // 检查响应数据类型
    if (response.data instanceof Blob) {
      console.log(response.data);
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + '.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      message.error('导出失败，请重试1');
    }
  }).catch((error) => {
    // 检查错误响应是否包含有效数据
    if (error) {
      // 根据错误响应数据进行相应处理
      if (error instanceof Blob) {
        const blob = new Blob([error], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        message.error('导出失败，请重试2');
      }
    } else {
      message.error('导出失败，请重试3');
    }
  }).finally(() => {
    // 移除遮罩层和转圈的提示
    document.body.removeChild(mask);
    document.head.removeChild(style);
  });
}
